import React from "react";
import { FormControl, Select, MenuItem, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setState, setTotalValues } from "./defineSlice";
import {
	getRowWeekPercents,
	NONE_DEPLETION_GRID_WEEK_PERCENTS,
	NONE_DEPLETION_WEEK_CURVE,
	rowDepletionModelKey,
	splitQuotaAcrossWeeks,
	commitGridDataUpdate,
	DEPLETION_TYPE_BACKUP_FIELDS,
} from "./defineUtils";

export default function TableCellDepletionType(params) {
	const dispatch = useDispatch();
	const {
		gridData,
		gridDataFiltered,
		depletionModelsList,
		selectedDepletion,
		weeklyDepletionValuesList,
		selectedDepletionPeriodType,
	} = useSelector((state) => state.define);

	function updateGrid(depletionModelID, depletionModelKey, depletionModelName) {
		const customerID = params.row.customerID;
		const customerGroupID = params.row.customerGroupID;
		const productGroupID = params.row.productGroupID;
		const skuid = params.row.skuid;
		let updatedItem = null;
		const updated = gridDataFiltered.map((item) => {
			const flag =
				item.customerID === customerID &&
				item.customerGroupID === customerGroupID &&
				item.productGroupID === productGroupID &&
				item.skuid === skuid;
			if (flag) {
				const rowWithNewModel = {
					...item,
					depletionModelID,
					depletionModel: depletionModelKey ?? "",
					depletionModelName: depletionModelName ?? "",
				};
				const dm = rowDepletionModelKey(rowWithNewModel);
				let weeklyPatch;
				let wc = {
					week1: 0,
					week2: 0,
					week3: 0,
					week4: 0,
					week5: 0,
				};
				if (dm === "none") {
					weeklyPatch = { ...NONE_DEPLETION_GRID_WEEK_PERCENTS };
					wc = { ...NONE_DEPLETION_WEEK_CURVE };
				} else if (!dm) {
					weeklyPatch = {
						weekly1Per: 0,
						weekly2Per: 0,
						weekly3Per: 0,
						weekly4Per: 0,
						weekly5Per: 0,
					};
				} else {
					wc = getRowWeekPercents(
						weeklyDepletionValuesList,
						selectedDepletionPeriodType,
						rowWithNewModel
					);
					weeklyPatch = {
						weekly1Per: wc.week1,
						weekly2Per: wc.week2,
						weekly3Per: wc.week3,
						weekly4Per: wc.week4,
						weekly5Per: wc.week5,
					};
				}
				const quota = Number(item.quota);
				const weekBuckets = splitQuotaAcrossWeeks(
					quota,
					dm,
					wc,
					selectedDepletionPeriodType
				);
				updatedItem = {
					...rowWithNewModel,
					...weeklyPatch,
					...weekBuckets,
				};
				return updatedItem;
			}
			return item;
		});

		const updatedGrid = [];
		for (let i = 0; i < gridData.length; ++i) {
			const item = gridData[i];
			if (item.id === updatedItem.id) {
				updatedGrid.push(updatedItem);
			} else {
				updatedGrid.push(item);
			}
		}
		commitGridDataUpdate(dispatch, setState, {
			gridData: updatedGrid,
			gridDataFiltered: updated,
			updatedRow: updatedItem,
			backupFields: DEPLETION_TYPE_BACKUP_FIELDS,
		});
		dispatch(setState("gridDataChanged", true));
		dispatch(setTotalValues());
	}

	const rowId = params.row.depletionModelID;
	const timeMatch = depletionModelsList?.find(
		(m) => m.depletionModel === selectedDepletion?.key
	);
	const resolvedValue =
		rowId !== undefined && rowId !== null && rowId !== ""
			? rowId
			: timeMatch?.depletionModelID ?? depletionModelsList?.[0]?.depletionModelID;

	const handleChange = (e) => {
		const id = e.target.value;
		const model = depletionModelsList.find((m) => m.depletionModelID == id);
		updateGrid(
			model?.depletionModelID ?? id,
			model?.depletionModel ?? "",
			model?.depletionModelName ?? ""
		);
	};

	if (!depletionModelsList || depletionModelsList.length === 0) {
		return (
			<Box sx={{ width: "100%", px: 0.5 }}>
				<Select size="small" fullWidth disabled value="" />
			</Box>
		);
	}

	if (resolvedValue === undefined || resolvedValue === null || resolvedValue === "") {
		return (
			<Box sx={{ width: "100%", px: 0.5 }}>
				<Select size="small" fullWidth disabled value="" />
			</Box>
		);
	}

	return (
		<Box sx={{ width: "100%", px: 0.5 }}>
			<FormControl size="small" fullWidth variant="outlined">
				<Select value={resolvedValue} onChange={handleChange}>
					{depletionModelsList.map((m) => (
						<MenuItem
							key={m.depletionModelID}
							value={m.depletionModelID}
						>
							{m.depletionModelName}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
}
